import { useQuery } from "@tanstack/react-query";

import userViewGuard from "~/hooks/useViewPermssionsCheck.tsx";
import { quotaQueries } from "~/modules/quota/api/quota/quotaQueries.ts";
import QuotasIndexView from "~/modules/quota/components/QuotasIndexView/QuotasIndexView.tsx";
import { QUOTA_ACCESS_PERMISSIONS } from "~/modules/quota/utils/quotaPermissionUtils.ts";
import LoadingPage from "~/pages/LoadingPage.tsx";

const QuotasIndexPage = () => {
	const guard = userViewGuard(QUOTA_ACCESS_PERMISSIONS);
	if (guard) return guard;

	const {
		data: quotasData,
		isLoading: quotasIsLoading,
	} = useQuery(quotaQueries.index());


	if (quotasIsLoading) return <LoadingPage />;
	if (!quotasData) return null;

	return <QuotasIndexView quotas={quotasData}/>;
};

export default QuotasIndexPage;